var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-form-group"},[_c('transition',{attrs:{"name":"flixFadeIn"}},[_c('holidayEditor',{key:_vm.$route.params.id,attrs:{"id":_vm.$route.params.id},on:{"save":_vm.setSave}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }